import CommonDelete from "@/components/CommonUi/CommonDelete";
import CreateDrawer from "@/components/CommonUi/CreateDrawer";
import TableComponent from "@/components/CommonUi/TableComponent";
import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { useGetLeadStatusesPaginatedQuery } from "@/redux/rtk/features/leadStatus/leadStatusApi";

import Modal from "@/UI/Modal";
import { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { useTranslation } from "react-i18next";
import AddLeadStatus from "./AddLeadStatus";
import UpdateLeadStatus from "./UpdateLeadStatus";
import { Tag } from "antd";

export default function GetAllLeadStatus() {
  const { t } = useTranslation();

  const [pageConfig, setPageConfig] = useState({
    page: 1,
    count: 10,
  });
  const { data, isLoading } = useGetLeadStatusesPaginatedQuery(pageConfig);
  const [edit, setEdit] = useState(null);

  const columns = [
    {
      title: t("common.id"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("leadStatus.name"),
      key: "name",
      dataIndex: "name",
      render: (name, record) => (
        <Tag color={record.color || record.colorCode || "#1677FF"}>
          {name}
        </Tag>
      ),
    },
    {
      title: t("leadStatus.colorCode"),
      key: "color",
      dataIndex: "color",
      render: (color, record) => color || record.colorCode || "#1677FF",
    },

    {
      title: "",
      key: "action",
      render: (item) => [
        {
          label: (
            <span className="cursor-pointer" onClick={() => setEdit(item)}>
              <button className="flex justify-center items-center gap-2 rounded">
                <CiEdit /> {t("common.edit")}
              </button>
            </span>
          ),
          key: "edit",
        },
        {
          label: (
            <CommonDelete
              id={item.id}
              title={t("common.delete")}
              permission={"delete-leadStatus"}
              deleteThunk={apiSlice.endpoints.deleteLeadStatus.initiate}
              query={pageConfig}
              className="bg-white text-black"
            />
          ),
          key: "delete",
        },
      ],
    },
  ];

  return (
    <UserPrivateComponent permission={"readAll-leadStatus"}>
      <TableComponent
        list={data?.getAllLeadStatus}
        total={data?.totalLeadStatus}
        columns={columns}
        loading={isLoading}
        setPageConfig={setPageConfig}
        title={t("leadStatus.leadStatusList")}
        componentTitle={t("leadStatus.title")}
        extra={
          <CreateDrawer
            permission={"create-leadStatus"}
            title={t("leadStatus.createLeadStatus")}
            width={30}>
            <AddLeadStatus />
          </CreateDrawer>
        }
      />
      <Modal
        open={edit}
        onClose={() => setEdit(false)}
        className=" px-5 "
        title={t("leadStatus.editLeadStatus")}>
        <UpdateLeadStatus data={edit} onClose={() => setEdit(false)} />
      </Modal>
    </UserPrivateComponent>
  );
}
